<template>
  <div class="example">
    <toptitle :title1="titlework" />
    <p class="blank"><span>*</span>户籍地址</p>
    <div>
      <van-cell @click="showPopup1" title="选择城市" is-link :value="value1" />
      <van-popup v-model="show1">
        <div>
          <van-search
            v-model="search"
            @input="(value) => searchcity(value)"
            placeholder="请输入搜索关键词"
          />
        </div>
        <van-picker
          title="请选择城市"
          show-toolbar
          :columns="columns1"
          @confirm="onConfirm1"
          @cancel="onCancel1"
          ref="cityPicker"
        />
      </van-popup>
    </div>
    <van-field v-model="message1" rows="1" autosize type="textarea" />
    <p class="blank"> <span>*</span> 居住地址</p>
    <div>
      <van-cell @click="showPopup2" title="选择城市" is-link :value="value2" />
      <van-popup v-model="show2">
        <div>
          <van-search
            v-model="search"
            @input="(value) => searchcity(value)"
            placeholder="请输入搜索关键词"
          />
        </div>
        <van-picker
          title="请选择城市"
          show-toolbar
          :columns="columns1"
          @confirm="onConfirm2"
          @cancel="onCancel1"
          ref="cityPicker"
        />
      </van-popup>
    </div>
    <van-field v-model="message2" rows="1" autosize type="textarea" />
    <p class="blank">家庭地址</p>
    <div>
      <van-cell @click="showPopup3" title="选择城市" is-link :value="value3" />
      <van-popup v-model="show3">
        <div>
          <van-search
            v-model="search"
            @input="(value) => searchcity(value)"
            placeholder="请输入搜索关键词"
          />
        </div>
        <van-picker
          title="请选择城市"
          show-toolbar
          :columns="columns1"
          @confirm="onConfirm3"
          @cancel="onCancel1"
          ref="cityPicker"
        />
      </van-popup>
    </div>
    <van-field v-model="message3" rows="1" autosize type="textarea" />
    <div class="button-bt">
      <div @click="submit">提交</div>
      <div @click="cancel">取消</div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import toptitle from "../../components/toptitle";
import { changeResumeDataApi, changeDataApi } from "../../request/api";
import loginVue from "../login.vue";
export default {
  data() {
    name: "example";
    return {
      titlework: "编辑地址信息",
      message1: this.$route.query.ADDRESS1,
      message2: this.$route.query.ADDRESS2,
      message3: this.$route.query.ADDRESS3,
      show1: false,
      show2: false,
      show3: false,
      columns: [],
      columns1: [],
      value1: this.$route.query.C_CITY,
      value2: this.$route.query.C_CITY1,
      value3: this.$route.query.C_CITY2,
      search: "",

    };
  },
  methods: {
    searchcity(value, index) {
      let _this = this;
      for (let i = 0; i < this.columns.length; i++) {
        if (
          _this.columns[i].XLATLONGNAME == value ||
          _this.columns[i].XLATSHORTNAME == value
        ) {
          this.$refs.cityPicker.setColumnIndex(0, i);
          break;
        }
      }
    },
    showPopup1() {
      this.show1 = true;
      console.log(this.$route.query);
    },
    showPopup2() {
      this.show2 = true;
    },
    showPopup3() {
      this.show3 = true;
    },
    cancel() {
      this.$router.push("/resume");
    },
    submit() {
      let add1 = "";
      let add2 = "";
      let add3 = "";
      for (var i = 0; i < this.columns1.length; i++) {
        if (
          this.columns[i].XLATLONGNAME == this.value1 ||
          this.columns[i].XLATSHORTNAME == this.value1
        ) {
          add1 = this.columns[i].FIELDVALUE;
        }
        if (
          this.columns[i].XLATLONGNAME == this.value2 ||
          this.columns[i].XLATSHORTNAME == this.value2
        ) {
          add2 = this.columns[i].FIELDVALUE;
        }
        if (
          this.columns[i].XLATLONGNAME == this.value3 ||
          this.columns[i].XLATSHORTNAME == this.value3
        ) {
          add3 = this.columns[i].FIELDVALUE;
        }
      }
      var myDate = new Date();
      var time = myDate.toLocaleDateString().split("/").join("-");
      if(!this.message1){
        Toast("户籍地址必填")
        return;
      }
      if(!this.message2){
        Toast("居住地址必填")
        return;
      }
      let params = {
        security: {
          signTxt: "OTQ5QKE3NJJFNDQ0Q0JFM0JDNURDNJM2MTG4NKIWQJM3=",
          ipAddress: "10.19.185.14",
          system: "SELF",
          pubkeyRmk: "Z7PCKFDMBPVHGS0ZGDQT",
        },
        parameters: {
          TYPE: "1",
          EMPLID: sessionStorage.getItem("EMPLID"),
          DATE: time,
          COUNTRY_ID: "CHN",
          C_CITY_ID: add1,
          ADDRESS1: this.message1,
          COUNTRY_ID2: "CHN",
          C_CITY_ID2: add2,
          ADDRESS2: this.message2,
          COUNTRY_ID3: "CHN",
          C_CITY_ID3: add3,
          ADDRESS3: this.message3,
        },
      };
      console.log(params);
      changeResumeDataApi(params).then((res) => {
        console.log(res);
        if (res.CODE == 1) {
          Toast.success("提交成功");
          this.$router.back(-1);
        } else {
          Toast.fail(res.MESSAGE);
        }
      });
    },
    onConfirm1(value, index) {
      this.value1 = value;
      this.search = "";
      this.show1 = false;
    },
    onConfirm2(value, index) {
      this.value2 = value;
      this.show2 = false;
    },
    onConfirm3(value, index) {
      this.value3 = value;
      this.show3 = false;
    },
    onCancel1() {
      Toast("取消");
      this.show1 = false;
      this.show2 = false;
      this.show3 = false;
    },
  },
  components: {
    toptitle,
  },
  created() {
    let params = {
      FIELDNAME: "C_CITY",
    };
    changeDataApi(params).then((res) => {
      if (res.RESULTCODE == 1) {
        this.columns = res.DATA;
        this.columns1 = this.columns.map((index) => {
          return index.XLATLONGNAME;
        });
        // console.log(this.columns);
        // console.log(this.columns1);
      }
    });
  },
};
</script>

<style lang="less" scoped>
/deep/ .van-popup {
  width: 80%;
}
/deep/ .van-cell__title {
  font-size: 17px;
}
.blank {
  height: 44px;
  line-height: 44px;
  font-size: 14px;
  padding: 0 16px;
  color: #888888;
  span{
    color: red;
  }
}
/deep/.van-field__control {
  font-size: 17px;
}

.button-bt {
  position: fixed;
  bottom: 0;
  display: flex;
  line-height: 44px;
  text-align: center;
  color: white;
  width: 100%;
  div {
    background: #733e2a;
    width: 50%;
    font-size: 17px;
  }
}
</style>
